import React, { useState, useEffect } from "react";
import { companyPostViewService } from "../../services/compayPostView.service";
import {ItemMorePostSecondary} from "./itemMorePostSecondary";

export function AsideBlogCompanySecondary({
  getPost,
  postType,
  activeAsideSurvey,
  postCategoryId,
  setLastFiter,
}) {
  const [filter, setFilter] = useState([]);
  const [filterId, setFilterId] = useState(0);

  useEffect(() => {
    companyPostViewService
        .getDateFilters(postType, postCategoryId)
        .then((result) => {
          if (result) {
            setFilter([]);
            if (result && result.length > 0) {
              setFilter(result);
              let lastItem = result[0];
              let lastMonth = lastItem.months[0];
              lastMonth.postType = postCategoryId;
              setLastFiter(lastMonth);
              setFilterId(postCategoryId)
            }
          }
        });
  }, [postType, postCategoryId]);

  return (
      <div className="publications-list">
          {filter.map((item,i) => (
              <ItemMorePostSecondary filter={item} getPost={getPost} year={item.year} months={item.months} key={i} />
          ))}
      </div>
  );
}
